module.exports = __webpack_public_path__ + "img/gohome.33ae072b.svg";